import { RouterProvider } from 'react-router-dom';
import { router } from './routes/AppRoutes';

function App() {
  return (
    <main className="app">
      <RouterProvider router={router} />
    </main>
  );
}

export default App;
